/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentSplitDto } from './PaymentSplitDto';
import {
    PaymentSplitDtoFromJSON,
    PaymentSplitDtoFromJSONTyped,
    PaymentSplitDtoToJSON,
    PaymentSplitDtoToJSONTyped,
} from './PaymentSplitDto';
import type { TerminalTipDistributionType } from './TerminalTipDistributionType';
import {
    TerminalTipDistributionTypeFromJSON,
    TerminalTipDistributionTypeFromJSONTyped,
    TerminalTipDistributionTypeToJSON,
    TerminalTipDistributionTypeToJSONTyped,
} from './TerminalTipDistributionType';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface InitiateAdyenTerminalPaymentV2Request
 */
export interface InitiateAdyenTerminalPaymentV2Request {
    /**
     * 
     * @type {number}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    amountMinorUnits: number;
    /**
     * 
     * @type {Currency}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    paymentReference: string;
    /**
     * 
     * @type {Array<PaymentSplitDto>}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    paymentSplits: Array<PaymentSplitDto>;
    /**
     * 
     * @type {boolean}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    printReceipt: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    terminalId: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    shopperLocale?: string | null;
    /**
     * 
     * @type {TerminalTipDistributionType}
     * @memberof InitiateAdyenTerminalPaymentV2Request
     */
    terminalTipDistributionType?: TerminalTipDistributionType | null;
}



/**
 * Check if a given object implements the InitiateAdyenTerminalPaymentV2Request interface.
 */
export function instanceOfInitiateAdyenTerminalPaymentV2Request(value: object): value is InitiateAdyenTerminalPaymentV2Request {
    if (!('amountMinorUnits' in value) || value['amountMinorUnits'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentSplits' in value) || value['paymentSplits'] === undefined) return false;
    if (!('printReceipt' in value) || value['printReceipt'] === undefined) return false;
    if (!('terminalId' in value) || value['terminalId'] === undefined) return false;
    return true;
}

export function InitiateAdyenTerminalPaymentV2RequestFromJSON(json: any): InitiateAdyenTerminalPaymentV2Request {
    return InitiateAdyenTerminalPaymentV2RequestFromJSONTyped(json, false);
}

export function InitiateAdyenTerminalPaymentV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateAdyenTerminalPaymentV2Request {
    if (json == null) {
        return json;
    }
    return {
        
        'amountMinorUnits': json['amountMinorUnits'],
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'orderReference': json['orderReference'],
        'paymentReference': json['paymentReference'],
        'paymentSplits': ((json['paymentSplits'] as Array<any>).map(PaymentSplitDtoFromJSON)),
        'printReceipt': json['printReceipt'],
        'terminalId': json['terminalId'],
        'shopperLocale': json['shopperLocale'] === undefined ? undefined : json['shopperLocale'] === null ? null : json['shopperLocale'],
        'terminalTipDistributionType': json['terminalTipDistributionType'] === undefined ? undefined : json['terminalTipDistributionType'] === null ? null : TerminalTipDistributionTypeFromJSON(json['terminalTipDistributionType']),
    };
}

export function InitiateAdyenTerminalPaymentV2RequestToJSON(json: any): InitiateAdyenTerminalPaymentV2Request {
    return InitiateAdyenTerminalPaymentV2RequestToJSONTyped(json, false);
}

export function InitiateAdyenTerminalPaymentV2RequestToJSONTyped(value?: InitiateAdyenTerminalPaymentV2Request | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amountMinorUnits': value['amountMinorUnits'],
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'orderReference': value['orderReference'],
        'paymentReference': value['paymentReference'],
        'paymentSplits': ((value['paymentSplits'] as Array<any>).map(PaymentSplitDtoToJSON)),
        'printReceipt': value['printReceipt'],
        'terminalId': value['terminalId'],
        'shopperLocale': value['shopperLocale'],
        'terminalTipDistributionType': TerminalTipDistributionTypeToJSON(value['terminalTipDistributionType']),
    };
}

